import React, { Component } from 'react';
import { Form, FormGroup, FormError } from '../../components/Forms/Forms';
import { Input } from '../../components/Forms/fields';
import rules from '../../components/Forms/rules';

class LoginView extends Component {

  render() {
    const { auth, loginFormLoading, submitLogin, onFormUpdate, loginFormState } = this.props;
    const errorMessage = auth.errorMessage;
    return (
      <div className="login-view">
        <h2>Login</h2>
        {errorMessage ? (
          <div className="error-message">
            {errorMessage}
          </div>
        ) : null}

        <Form state={loginFormState} onSubmit={submitLogin} onChange={onFormUpdate}>
          <FormGroup name="username">
            <label>Username</label>
            <Input name="username" type="text" validate={[rules.required()]}/>
            <FormError />
          </FormGroup>
          <FormGroup name="password">
            <label>Password</label>
            <Input name="password" type="password" validate={[rules.required()]}/>
            <FormError />
          </FormGroup>
          <FormGroup name="code">
            <label>Code</label>
            <Input name="code" type="text" />
            <FormError />
          </FormGroup>
          <button className="button">{loginFormLoading ? 'Loading...' : 'LOGIN'}</button>
        </Form>

      </div>
    );
  }
}

export default LoginView;



// WEBPACK FOOTER //
// ./src/app/modules/Login/Login.view.js